<template lang="pug">
  include ../../../../../pug/mixins/bem
  div
    +b.poll-title--centered.H1 {{ _('Дякуємо за ваші відповіді') }}
      +e.icon.svgicon-smile.SPAN
    +b.poll-text.P {{ _('Даруємо вам промокод на 15% знижки для купівлі продукції бренду Milupa в офіційному інтернет магазині shop.nutricia.ua') }}
    +b.poll-promo
      +e.title.P {{ _('Ваш промокод:') }}
      +e.wrap
        +e.code.P {{ promo }} 
        transition(name='slidedown')
          +e.success(v-if='show') {{ _('Промокод успішно скопійован') }}
        +b.promo-tip(
          v-clipboard:copy="promo"
          v-clipboard:success="successPromo"
        )
          +e.icon.svgicon-copy
          +e.text.P {{ _('Копіювати код') }}
      +e.info.P {{ _('Промокод можна використати 1 раз. Знижка діє на продукцію для дітей віком старше 6-ти місяців. Промокод дійсний до 31.08.2021 включно.') }}  
      +b.poll-btn.BUTTON(
        href='',
        @click.prevent='next(false)'
      ) {{ _('Завершити') }}
      +e.btn.poll-btn--grey.BUTTON(
        href='',
        @click.prevent='next(true)'
        target='_blank'
      ) {{ _('У магазин') }}
  
</template>

<script>
const SHOP_NUTRICIA_LINK = 'https://shop.nutricia.ua/'
export default {
  name: 'Products',
  data() {
    return {
      promo: window.promo,
      show: false
    }
  },
  methods: {
    successPromo() {
      this.show = true
      setTimeout(() => {
        this.show = false

      }, 2000)
    },
    next(is_link) {
      let obj = {
        current: '',
        finish: true,
        given_promocode: this.promo,
        save: is_link
      }
      this.$emit('next', obj)
      if (is_link) {
        window.open(SHOP_NUTRICIA_LINK, { target: '_blank' })
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/poll/steps/promo.vue